module.exports = __webpack_public_path__ + "static/media/Winged Star_3c.44a00e5d.svg";